if (!customElements.get('cinoton-sticky-story')) {
  customElements.define('cinoton-sticky-story', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.steps = Array.from(this.querySelectorAll('[data-cinoton-sticky-step]'));
      this.media = Array.from(this.querySelectorAll('[data-cinoton-sticky-media]'));
      this.activeIndex = 0;
      if (!this.steps.length) return;

      this.activate(0);
      this.observer = new IntersectionObserver((entries) => {
        const candidates = entries.filter((entry) => entry.isIntersecting);
        if (!candidates.length) return;
        const viewportCenter = window.innerHeight / 2;
        candidates.sort((a, b) => {
          const aCenter = a.boundingClientRect.top + a.boundingClientRect.height / 2;
          const bCenter = b.boundingClientRect.top + b.boundingClientRect.height / 2;
          return Math.abs(aCenter - viewportCenter) - Math.abs(bCenter - viewportCenter);
        });
        const index = this.steps.indexOf(candidates[0].target);
        if (index >= 0) this.activate(index);
      }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
      this.steps.forEach((step) => this.observer.observe(step));

      this.addEventListener('shopify:block:select', (event) => {
        const step = event.target.closest('[data-cinoton-sticky-step]');
        const index = this.steps.indexOf(step);
        if (index >= 0) this.activate(index);
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    activate(nextIndex) {
      this.activeIndex = nextIndex;
      const activeId = this.steps[nextIndex]?.dataset.cinotonStickyStep;
      this.steps.forEach((step, index) => {
        step.classList.toggle('is-before', index < nextIndex);
        step.classList.toggle('is-active', index === nextIndex);
        step.classList.toggle('is-after', index > nextIndex);
      });
      this.media.forEach((item) => {
        const active = item.dataset.cinotonStickyMedia === activeId;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', String(!active));
      });
    }
  });
}
